module.exports = __webpack_public_path__ + "static/media/9-iron.e49c86a4.png";